import * as React from 'react'
import { SVGProps } from 'react'
const SvgRewards = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    viewBox="0 0 80 55"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.8511 26.6216C19.9134 26.6216 19.9757 26.625 20.0363 26.6319C19.9757 26.625 19.9142 26.6216 19.8511 26.6216Z"
      fill="#61763D"
    />
    <path
      d="M21.4147 28.5292L19.3292 39.2339L19.2925 39.4226L21.4147 28.5283C21.4506 28.343 21.454 28.1603 21.4275 27.9854C21.4531 28.1603 21.4506 28.343 21.4147 28.5283V28.5292Z"
      fill="#61763D"
    />
    <path
      d="M29.0511 50.2769C29.361 50.3524 29.6743 50.4133 29.9902 50.463C30.8703 50.5625 31.7565 50.5642 32.6366 50.4647C33.2231 50.3712 33.7993 50.2323 34.361 50.0444L36.5183 36.2595C36.5004 36.2509 36.4833 36.2415 36.4662 36.2329L32.4906 41.0458C32.4795 42.0828 32.3626 43.1189 32.1372 44.1457C31.6361 46.4273 30.5605 48.5399 29.0503 50.2769H29.0511Z"
      fill="#FFA9DF"
    />
    <path
      d="M29.7669 32.5854C30.2543 33.2098 30.6794 33.8772 31.0406 34.5771H33.5085C32.0735 33.6927 30.6991 32.7175 29.369 31.6745C28.6093 31.0783 27.8623 30.4616 27.1512 29.8071L27.0889 30.1631C28.1124 30.8073 29.0242 31.6341 29.7669 32.5845V32.5854Z"
      fill="#FFA9DF"
    />
    <path
      d="M38.3063 18.54C38.6017 18.8513 38.8783 19.1756 39.1404 19.5101L39.4554 17.4995H37.1846C37.5832 17.8246 37.9589 18.1728 38.3072 18.54H38.3063Z"
      fill="#FFA9DF"
    />
    <path
      d="M31.5451 29.1646L30.2825 27.7236C29.8957 27.2921 29.7318 26.678 29.8334 26.0424C29.9427 25.3613 30.3456 24.7609 30.9108 24.4358L30.9782 24.3972C31.4324 24.1373 31.936 24.0807 32.3962 24.2385C32.8486 24.3938 33.2046 24.7377 33.4001 25.2086L36.2719 32.3434C36.534 32.4935 36.7978 32.6393 37.0633 32.7826L38.3122 24.802C38.2695 24.6897 38.226 24.5782 38.1807 24.4667C37.736 23.4485 37.1964 22.4775 36.5365 21.5846C36.0568 20.9911 35.5224 20.4507 34.9308 19.9695C34.3759 19.5603 33.7843 19.2078 33.1577 18.9222C32.6275 18.7154 32.0803 18.5619 31.5186 18.4667C31.0687 18.4221 30.618 18.4178 30.1681 18.4581C29.8035 18.5216 29.4467 18.6168 29.0993 18.7429L29.3178 17.5L27.4482 28.1207L27.8597 25.7842C28.9465 27.0434 30.2415 28.1396 31.5442 29.1654L31.5451 29.1646Z"
      fill="#FFA9DF"
    />
    <path
      d="M32.4759 40.1902L35.9606 35.9717C35.6285 35.7968 35.299 35.6175 34.9738 35.4365C34.7313 35.3018 34.4914 35.1646 34.2524 35.0239H31.2603C31.7076 35.9855 32.0362 37.0028 32.2317 38.0544C32.3632 38.7637 32.4452 39.4774 32.4776 40.1902H32.4759Z"
      fill="#FFA9DF"
    />
    <path
      d="M37.478 33.0031C37.6146 33.0743 37.7521 33.1446 37.8895 33.2132L39.7317 30.2051C39.4714 28.6706 39.1222 27.1446 38.6262 25.6719L37.4789 33.0031H37.478Z"
      fill="#FFA9DF"
    />
    <path
      d="M26.4363 33.875L26.3125 34.5775H27.1013C26.8904 34.3322 26.6693 34.098 26.4363 33.875Z"
      fill="#FFA9DF"
    />
    <path
      d="M25.7803 48.8752C26.1995 48.4866 26.5896 48.0672 26.949 47.6203C27.4817 46.8972 27.9299 46.1184 28.2944 45.2966C28.6658 44.3608 28.9278 43.3864 29.0806 42.3906C29.1959 41.3819 29.1976 40.3646 29.0832 39.3559C28.9398 38.4278 28.6973 37.5203 28.3507 36.6479C28.0955 36.0792 27.7959 35.5363 27.445 35.0233H26.2336L26.2695 34.8218L24.0269 47.5611C24.2548 47.7661 24.4896 47.9634 24.7294 48.1555C25.0701 48.4103 25.4201 48.6505 25.7803 48.8752Z"
      fill="#FFA9DF"
    />
    <path
      d="M49.2856 21.8046C49.6578 22.2806 50.0437 22.7464 50.4389 23.2044L51.0869 17.4995H47.043C47.1411 17.9215 47.2709 18.3358 47.428 18.7407C47.9154 19.8369 48.5651 20.8482 49.2847 21.8046H49.2856Z"
      fill="#FFA9DF"
    />
    <path
      d="M40.1989 34.2401C40.1647 33.7177 40.1203 33.197 40.0674 32.6772L38.938 33.7177C39.1198 33.8009 39.3025 33.8824 39.4852 33.9622C39.7217 34.0591 39.959 34.1526 40.1989 34.2409V34.2401Z"
      fill="#FFA9DF"
    />
    <path
      d="M42.2474 26.0955L42.8142 25.1692C43.1293 24.6648 43.6099 24.3097 44.1349 24.193C44.5728 24.0961 45.0116 24.1707 45.371 24.4049L45.4299 24.4435C45.8721 24.7317 46.1521 25.2318 46.1974 25.8159C46.2537 26.5338 45.9643 27.2552 45.4222 27.7459L43.0447 29.934C43.084 30.1896 43.1224 30.4443 43.1574 30.6991C43.3367 31.9883 43.4673 33.2809 43.5407 34.577H46.3698C46.4048 34.5641 46.4407 34.5521 46.4765 34.5384C47.104 34.251 47.693 33.8925 48.2496 33.4834C48.6483 33.1626 49.0265 32.8177 49.3867 32.4558L49.9425 27.5692C49.1392 26.7577 48.3683 25.9154 47.6341 25.0405C46.1624 23.2873 44.817 21.4216 44.0683 19.2335C43.8745 18.6674 43.7405 18.0858 43.6645 17.5H39.9049L39.5122 20.0115C40.8004 21.8239 41.6567 23.9229 42.2483 26.0964L42.2474 26.0955Z"
      fill="#FFA9DF"
    />
    <path
      d="M48.8622 37.0767C48.6582 37.1899 48.4507 37.2971 48.2399 37.3957C47.0908 37.931 45.9375 38.2449 44.6723 38.347C44.3112 38.3762 43.9476 38.3796 43.5839 38.3659C43.5105 40.4373 43.3107 42.538 42.807 44.5485C42.2889 46.6149 41.3908 48.574 39.9993 50.1934C39.3095 50.9954 38.4823 51.6696 37.5757 52.2134H47.1429L48.8631 37.0767H48.8622Z"
      fill="#FFA9DF"
    />
    <path
      d="M36.5666 48.8752C37.0233 48.4986 37.4382 48.0783 37.813 47.6186C38.2663 46.9975 38.6436 46.3294 38.9578 45.6277C39.4666 44.3557 39.779 43.0167 39.9813 41.6632L37.457 36.7148C37.2828 36.6342 37.1087 36.5518 36.9362 36.4678L34.8379 49.8727C34.8592 49.8642 34.8814 49.8564 34.9028 49.8479C35.4893 49.5802 36.0458 49.2569 36.5666 48.8752Z"
      fill="#FFA9DF"
    />
    <path
      d="M32.8852 25.4206C32.7537 25.1023 32.5156 24.8699 32.2159 24.7669C32.1041 24.7283 31.988 24.7095 31.8693 24.7095C31.6627 24.7095 31.4519 24.7678 31.2521 24.8819L31.1855 24.9205C30.7647 25.1624 30.4642 25.6144 30.3814 26.1308C30.3062 26.5991 30.4215 27.0443 30.6964 27.3522L33.6014 30.6666C34.2178 31.0886 34.8461 31.4952 35.4855 31.882L32.8844 25.4197L32.8852 25.4206Z"
      fill="#FFA9DF"
    />
    <path
      d="M45.0493 27.3333C45.459 26.9619 45.6861 26.3984 45.6443 25.8606C45.6119 25.4454 45.4283 25.1092 45.1278 24.9128L45.0689 24.8742C44.9016 24.7652 44.7121 24.7095 44.5115 24.7095C44.4278 24.7095 44.3424 24.7189 44.2554 24.7386C43.8746 24.8236 43.5212 25.0877 43.2864 25.4643L42.4404 26.8453C42.6368 27.6524 42.8007 28.4664 42.9381 29.2761L45.0493 27.3325V27.3333Z"
      fill="#FFA9DF"
    />
    <path
      d="M39.9913 31.9894C39.9742 31.8445 39.9571 31.6995 39.9392 31.5545C39.9153 31.3864 39.8914 31.2183 39.8658 31.0493L38.3906 33.4587C38.3906 33.4587 38.3923 33.4596 38.3932 33.4605L39.9913 31.9886V31.9894Z"
      fill="#FFA9DF"
    />
    <path
      d="M38.2627 37.0708L40.099 40.6699C40.1954 39.7153 40.2552 38.7563 40.2774 37.7956C39.5944 37.5949 38.9234 37.3487 38.2635 37.0708H38.2627Z"
      fill="#FFA9DF"
    />
    <path
      d="M33.6025 30.6665L36.1824 33.6103L35.4866 31.8819C34.8464 31.4951 34.218 31.0885 33.6025 30.6665Z"
      fill="#FFD7F0"
    />
    <path
      d="M35.9605 35.9719L36.6512 35.1356L36.5948 35.0249H34.2515C34.4905 35.1647 34.7304 35.3028 34.9728 35.4375C35.2981 35.6185 35.6276 35.7977 35.9597 35.9727L35.9605 35.9719Z"
      fill="#FFD7F0"
    />
    <path
      d="M33.5089 34.5772H36.2893L31.5454 29.164C30.2427 28.1381 28.9476 27.0428 27.8609 25.7827L27.4494 28.1192L27.1523 29.8073C27.8635 30.4618 28.6104 31.0785 29.3702 31.6746C30.6994 32.7176 32.0747 33.692 33.5097 34.5772H33.5089Z"
      fill="#FFD7F0"
    />
    <path
      d="M39.9917 31.9892L42.9386 29.2761C42.8003 28.4664 42.6373 27.6524 42.4409 26.8452L39.8662 31.0499C39.8918 31.218 39.9157 31.3862 39.9396 31.5551C39.9584 31.7001 39.9746 31.8451 39.9917 31.99V31.9892Z"
      fill="#FFD7F0"
    />
    <path
      d="M30.1681 18.4581C30.6179 18.4178 31.0695 18.4221 31.5186 18.4667C32.0803 18.561 32.6267 18.7154 33.1576 18.9222C33.7842 19.2078 34.3758 19.5603 34.9307 19.9695C35.5215 20.4507 36.0567 20.9919 36.5365 21.5846C37.1964 22.4775 37.7359 23.4485 38.1807 24.4667C38.2259 24.5782 38.2686 24.6897 38.3122 24.802L39.1402 19.5106C38.879 19.1752 38.6016 18.851 38.3062 18.5405C37.9579 18.1733 37.5814 17.8251 37.1836 17.5H29.3186L29.1001 18.7429C29.4475 18.6168 29.8044 18.5216 30.1689 18.4581H30.1681Z"
      fill="#FFD7F0"
    />
    <path
      d="M38.391 33.4595L38.3857 33.4682L38.3936 33.4612C38.3936 33.4612 38.3919 33.4603 38.391 33.4595Z"
      fill="#FFD7F0"
    />
    <path
      d="M47.6345 25.0409C48.3687 25.9158 49.1396 26.7589 49.9429 27.5695L50.4389 23.2044C50.0436 22.7464 49.6578 22.2806 49.2856 21.8046C48.565 20.8482 47.9154 19.8369 47.4288 18.7407C47.2717 18.3358 47.142 17.9215 47.0438 17.4995H43.6641C43.74 18.0854 43.8741 18.6669 44.0679 19.233C44.8165 21.4212 46.1628 23.2868 47.6337 25.04L47.6345 25.0409Z"
      fill="#FFD7F0"
    />
    <path
      d="M46.4768 34.5392C46.4418 34.5529 46.406 34.564 46.3701 34.5778H49.1463L49.387 32.4565C49.0259 32.8185 48.6486 33.1633 48.2499 33.4841C47.6942 33.8941 47.1043 34.2518 46.4768 34.5392Z"
      fill="#FFD7F0"
    />
    <path
      d="M32.6361 50.4643C31.7559 50.5638 30.8698 50.5621 29.9896 50.4626C29.6738 50.4129 29.3605 50.3511 29.0506 50.2765C30.5608 48.5395 31.6364 46.4269 32.1375 44.1453C32.3629 43.1185 32.4798 42.0832 32.4909 41.0454L31.8942 41.7684L31.4665 41.4116L32.4756 40.1902C32.4431 39.4774 32.362 38.7637 32.2297 38.0544C32.0342 37.0028 31.7064 35.9855 31.2582 35.0239H27.4448C27.7965 35.5369 28.0962 36.079 28.3506 36.6485C28.6963 37.5208 28.9396 38.4283 29.083 39.3564C29.1974 40.366 29.1949 41.3824 29.0805 42.3912C28.9277 43.387 28.6656 44.3606 28.2942 45.2972C27.9297 46.119 27.4815 46.8978 26.9488 47.6209C26.5894 48.0678 26.1985 48.4864 25.7801 48.8758C25.4199 48.6519 25.0699 48.4109 24.7293 48.1561C24.4894 47.964 24.2546 47.7667 24.0267 47.5617L23.208 52.2133H34.0207L34.3605 50.044C33.7988 50.231 33.2217 50.3708 32.6361 50.4643Z"
      fill="#FFD7F0"
    />
    <path
      d="M37.2925 34.1888L37.8892 33.2136C37.7518 33.1441 37.6143 33.0738 37.4777 33.0034L37.2925 34.1888Z"
      fill="#FFD7F0"
    />
    <path
      d="M36.5358 36.1484L36.4658 36.2334C36.4829 36.2419 36.5008 36.2514 36.5179 36.2599L36.535 36.1484H36.5358Z"
      fill="#FFD7F0"
    />
    <path
      d="M31.0408 34.5772C30.6805 33.8764 30.2554 33.2091 29.7671 32.5855C29.0244 31.6351 28.1127 30.8082 27.0891 30.1641L26.436 33.8747C26.6691 34.0977 26.8902 34.3327 27.1011 34.5772H31.0399H31.0408Z"
      fill="#FFD7F0"
    />
    <path
      d="M38.6259 25.6719C39.1218 27.1447 39.471 28.6706 39.7314 30.2051L42.2472 26.0956C41.6556 23.9221 40.7993 21.8232 39.5111 20.0107L38.625 25.6719H38.6259Z"
      fill="#FFD7F0"
    />
    <path
      d="M39.9985 50.1933C41.3909 48.5747 42.289 46.6147 42.8063 44.5484C43.31 42.5378 43.5097 40.4372 43.5831 38.3657C43.9468 38.3795 44.3113 38.376 44.6716 38.3469C45.9367 38.2448 47.0901 37.9308 48.2391 37.3956C48.45 37.297 48.6574 37.1898 48.8614 37.0765L49.0945 35.0239H37.5169L37.3128 35.2118L38.2613 37.0714C38.9212 37.3484 39.5922 37.5955 40.2751 37.7962C40.2529 38.7569 40.1932 39.7158 40.0967 40.6705L40.6021 41.6621L40.1078 41.9168L39.9789 41.6638C39.7766 43.0182 39.4641 44.3563 38.9553 45.6283C38.6412 46.33 38.2638 46.999 37.8105 47.6192C37.4358 48.0789 37.0209 48.4992 36.5642 48.8758C36.0434 49.2575 35.4868 49.5808 34.9003 49.8485C34.879 49.857 34.8568 49.8648 34.8355 49.8733L34.4692 52.215H37.5732C38.4798 51.6712 39.307 50.997 39.9968 50.195L39.9985 50.1933Z"
      fill="#FFD7F0"
    />
    <path
      d="M43.0461 29.9349L40.0676 32.6772C40.1205 33.197 40.1649 33.7185 40.1991 34.24C39.9592 34.1525 39.7219 34.0582 39.4854 33.9612C39.3019 33.8815 39.12 33.8 38.9382 33.7168L38.0034 34.5771H43.5421C43.4687 33.281 43.3389 31.9884 43.1588 30.6992C43.1238 30.4453 43.0862 30.1905 43.0461 29.9341V29.9349Z"
      fill="#FFD7F0"
    />
    <path
      d="M36.8909 33.8826L37.0633 32.7829C36.7978 32.6397 36.5341 32.4939 36.272 32.3438L36.8909 33.8826Z"
      fill="#FFD7F0"
    />
    <path
      d="M37.0286 35.8749L36.9355 36.4667C37.108 36.5508 37.2821 36.6331 37.4563 36.7138L37.0277 35.874L37.0286 35.8749Z"
      fill="#FFD7F0"
    />
    <path
      d="M52.0867 17.4995H51.5352L51.4644 18.1205C51.6684 17.9104 51.875 17.7028 52.0867 17.4995Z"
      fill="#F365BF"
    />
    <path
      d="M63.1783 21.5556C61.3156 22.4082 59.5528 23.4709 57.9188 24.7104C56.068 26.1651 54.3991 27.842 52.9504 29.7008C52.8898 29.7823 52.8283 29.8629 52.7686 29.9452C53.7511 29.7016 54.7149 29.3791 55.6514 28.9957C57.2256 28.3087 58.7119 27.4346 60.082 26.3959C61.1133 25.5767 62.0703 24.6666 62.935 23.6734L62.6584 26.0725L63.3568 20.0099L63.4532 19.1719L63.1783 21.5556Z"
      fill="#F365BF"
    />
    <path
      d="M49.3019 43.6949C49.7415 42.8929 50.2367 42.1227 50.7847 41.3953C52.4374 39.2038 54.4257 37.3544 56.7076 35.8336C57.1327 35.5497 57.5681 35.2804 58.0094 35.0239H49.7816C49.698 35.2083 49.6152 35.3936 49.5358 35.5806C49.5085 35.6467 49.4829 35.7136 49.4564 35.7796L48.6514 42.8664C48.7291 43.0053 48.8127 43.1408 48.9041 43.2721C49.0295 43.4205 49.1619 43.5611 49.3019 43.6949Z"
      fill="#F365BF"
    />
    <path
      d="M57.1652 39.6018C55.8651 40.6345 54.6776 41.8053 53.6472 43.1108C53.2161 43.6864 52.8157 44.2834 52.4529 44.9027C52.8311 44.9121 53.2093 44.8949 53.5857 44.8555C54.512 44.7088 55.4101 44.4369 56.28 44.0861C57.5852 43.5122 58.8163 42.7823 59.9559 41.9237C60.2889 41.6586 60.6124 41.3824 60.9266 41.096L60.399 45.6781C59.6247 46.1704 58.8145 46.6062 57.9754 46.975C56.3995 47.6663 54.7826 48.1664 53.0531 48.247C52.3727 48.2788 51.6931 48.2307 51.0281 48.1055C50.7549 48.9813 50.5501 49.8776 50.4152 50.7868C50.3588 51.2612 50.3204 51.7372 50.3042 52.2133H59.646L61.6266 35.0239L61.3978 37.0131C59.9073 37.7361 58.4867 38.5973 57.1661 39.6018H57.1652Z"
      fill="#F365BF"
    />
    <path
      d="M54.2377 33.0176C53.0109 33.3599 51.7125 33.6369 50.4362 33.6807C50.2817 33.9766 50.1332 34.2759 49.9897 34.5779H58.8117C59.1882 34.3772 59.5698 34.185 59.9556 34.0023C60.5737 33.7107 61.2028 33.4414 61.8371 33.1892L61.9285 32.3992L62.3357 28.8618C60.986 29.9374 59.5151 30.8672 57.9648 31.6023C56.7637 32.1727 55.5173 32.6608 54.2368 33.0176H54.2377Z"
      fill="#F365BF"
    />
    <path
      d="M51.8842 22.7112C51.4975 23.225 51.121 23.7534 50.7625 24.2963L50.3877 27.5918C51.6136 26.0016 52.9829 24.5254 54.5016 23.2121C56.3985 21.5721 58.4806 20.1405 60.7266 19.028C61.3729 18.7081 62.0328 18.4199 62.6978 18.142C63 18.0159 63.3047 17.8881 63.6138 17.7723L63.6454 17.4995H57.3418C56.9721 17.7474 56.6102 18.0073 56.255 18.2766C54.6228 19.5684 53.163 21.0669 51.8842 22.7112Z"
      fill="#F365BF"
    />
    <path
      d="M56.7084 35.8338C54.4265 37.3546 52.4383 39.2039 50.7855 41.3954C50.2375 42.1219 49.7423 42.8922 49.3027 43.6951C49.1627 43.5613 49.0304 43.4206 48.9049 43.2722C48.8144 43.141 48.7307 43.0054 48.6522 42.8665L47.5894 52.2143H50.3041C50.3203 51.7382 50.3587 51.2622 50.415 50.7878C50.5499 49.8786 50.7548 48.9822 51.028 48.1065C51.693 48.2317 52.3725 48.2798 53.0529 48.248C54.7833 48.1674 56.4002 47.6673 57.9752 46.976C58.8144 46.608 59.6246 46.1723 60.3988 45.679L60.9264 41.0969C60.6123 41.3834 60.2887 41.6596 59.9558 41.9247C58.817 42.7841 57.5851 43.5132 56.2798 44.0871C55.4099 44.4379 54.5119 44.7089 53.5856 44.8565C53.2083 44.8959 52.8301 44.9131 52.4528 44.9036C52.8156 44.2843 53.216 43.6873 53.6471 43.1118C54.6775 41.8063 55.8649 40.6355 57.1651 39.6027C58.4857 38.5983 59.9071 37.7371 61.3968 37.014L61.6256 35.0249H58.0094C57.5672 35.2814 57.1327 35.5507 56.7075 35.8346L56.7084 35.8338Z"
      fill="#FFA9DF"
    />
    <path
      d="M58.8115 34.5772H61.6773L61.65 34.8148L61.8378 33.1885C61.2027 33.4407 60.5735 33.71 59.9563 34.0016C59.5704 34.1835 59.1889 34.3765 58.8124 34.5772H58.8115Z"
      fill="#FFA9DF"
    />
    <path
      d="M51.4639 18.1205L50.7622 24.2963C51.1208 23.7534 51.4972 23.2242 51.8839 22.7112C53.1628 21.0669 54.6226 19.5684 56.2548 18.2766C56.6099 18.0073 56.9719 17.7483 57.3415 17.4995H52.0863C51.8754 17.7028 51.6688 17.9104 51.4639 18.1205Z"
      fill="#FFA9DF"
    />
    <path
      d="M60.0812 26.3958C58.7111 27.4346 57.2248 28.3086 55.6506 28.9957C54.715 29.3791 53.7503 29.7016 52.7677 29.9452C52.8275 29.8637 52.889 29.7822 52.9496 29.7007C54.3983 27.842 56.0681 26.1651 57.918 24.7103C59.5519 23.4709 61.3148 22.4081 63.1775 21.5555L63.4524 19.1718L63.6138 17.772C63.3047 17.8878 63 18.0156 62.6978 18.1417C62.0327 18.4196 61.3728 18.7078 60.7266 19.0277C58.4806 20.1402 56.3984 21.5718 54.5016 23.2118C52.9829 24.5251 51.6136 26.0013 50.3877 27.5915L49.5938 34.5771H49.9899C50.1333 34.2751 50.2818 33.9758 50.4363 33.6798C51.7126 33.6361 53.011 33.3599 54.2378 33.0168C55.5183 32.6591 56.7647 32.1711 57.9658 31.6015C59.5161 30.8656 60.987 29.9366 62.3367 28.861L62.6576 26.0724L62.9342 23.6733C62.0686 24.6666 61.1125 25.5767 60.0812 26.3958Z"
      fill="#FFA9DF"
    />
    <path
      d="M49.7826 35.0239H49.5428L49.4565 35.7796C49.483 35.7136 49.5086 35.6467 49.5359 35.5806C49.6162 35.3945 49.6981 35.2092 49.7818 35.0239H49.7826Z"
      fill="#FFA9DF"
    />
    <path
      d="M61.6775 34.5774H49.5936L50.3876 27.5918L50.7623 24.2963L51.4641 18.1205L51.5349 17.4995H51.0876L50.4397 23.2044L49.9437 27.5695L49.3879 32.4561L49.1472 34.5774H38.0041L38.9389 33.717L40.0683 32.6766L43.0468 29.9343L45.4243 27.7462C45.9664 27.2556 46.2558 26.5342 46.1994 25.8163C46.1533 25.233 45.8742 24.7329 45.432 24.4439L45.3731 24.4053C45.0137 24.1711 44.5749 24.0956 44.1369 24.1934C43.6119 24.3101 43.1313 24.6652 42.8163 25.1695L42.2494 26.0959L39.7336 30.2054L37.8914 33.2135L37.2947 34.1888L37.4799 33.0034L38.6273 25.6722L39.5134 20.011L39.9061 17.4995H39.4562L39.1412 19.5101L38.3131 24.8016L37.0642 32.7821L36.8917 33.8817L36.2728 32.3429L33.401 25.2081C33.2064 24.7381 32.8495 24.3933 32.3971 24.238C31.937 24.0802 31.4333 24.1368 30.9791 24.3967L30.9117 24.4353C30.3466 24.7595 29.9436 25.3608 29.8343 26.0419C29.7328 26.6775 29.8967 27.2908 30.2834 27.7231L31.546 29.1641L36.2899 34.5774H26.3129L26.2702 34.8218L26.2344 35.0234H36.5946L36.651 35.134L35.9604 35.9704L32.4756 40.1888L31.4666 41.4102L31.8943 41.767L32.491 41.044L36.4666 36.2311L36.5366 36.1462L36.5195 36.2577L34.3623 50.0426L34.0225 52.2119H34.4724L34.8386 49.8702L36.937 36.4653L37.03 35.8734L37.4586 36.7132L39.9829 41.6615L40.1118 41.9146L40.6061 41.6598L40.1007 40.6683L38.2644 37.0691L37.316 35.2095L37.52 35.0217H49.0977L48.8646 37.0743L47.1444 52.211H47.5918L48.6546 42.8633L49.4596 35.7765L49.5458 35.0208H61.6288L61.6485 34.8536L61.6536 34.8124L61.6809 34.5748L61.6775 34.5774ZM38.3908 33.4597L39.866 31.0503L42.4407 26.8456L43.2867 25.4646C43.5214 25.088 43.8748 24.823 44.2556 24.7389C44.3427 24.7201 44.428 24.7098 44.5117 24.7098C44.7123 24.7098 44.9018 24.7655 45.0691 24.8745L45.128 24.9131C45.4285 25.1095 45.6121 25.4457 45.6445 25.8609C45.6864 26.3987 45.4593 26.9631 45.0495 27.3336L42.9384 29.2773L39.9914 31.9904L38.3934 33.4623L38.3857 33.4691L38.3908 33.4606V33.4597ZM33.6025 30.6669L30.6974 27.3525C30.4217 27.0446 30.3073 26.5994 30.3824 26.1311C30.4652 25.6147 30.7657 25.1618 31.1866 24.9208L31.2532 24.8822C31.4529 24.7681 31.6638 24.7098 31.8704 24.7098C31.9882 24.7098 32.1051 24.7286 32.217 24.7672C32.5166 24.8702 32.7548 25.1026 32.8863 25.4209L35.4874 31.8832L36.1832 33.6115L33.6034 30.6677L33.6025 30.6669Z"
      fill="#112231"
    />
    <path
      d="M16.057 39.0322L13.3799 52.203H25.3408C25.8274 47.813 26.314 43.4222 26.8006 39.0322H16.0562H16.057Z"
      fill="#61763D"
    />
    <path
      d="M28.0093 51.4868C28.122 51.3161 28.2031 51.1214 28.2449 50.9104C28.2039 51.1214 28.122 51.3161 28.0093 51.4868Z"
      fill="#61763D"
    />
    <path
      d="M18.2525 25.9962L8.61961 25.9773C8.59741 25.9765 8.57607 25.9739 8.55387 25.9722H6.19686C5.43538 25.9722 4.77975 26.5143 4.63377 27.2648L2.42871 38.5846H15.6941L18.2525 25.9953V25.9962Z"
      fill="#61763D"
    />
    <path
      d="M2.34142 39.0322L0.147459 50.2954C-0.0454728 51.2835 0.708328 52.203 1.71055 52.203H12.9262L15.6034 39.0322H2.34142Z"
      fill="#61763D"
    />
    <path
      d="M16.1479 38.5852H26.8514C27.1459 35.9305 27.4396 33.2766 27.7341 30.6219C27.8178 29.8705 27.8989 29.0951 27.6795 28.372C27.3704 27.3513 26.4929 26.5836 25.5214 26.1538C25.3797 26.0912 25.2362 26.0355 25.0903 25.9849L19.1213 25.9969H18.5152L18.6987 26.0338L16.1479 38.5852Z"
      fill="#61763D"
    />
    <path
      d="M28.5866 25.9782L25.0908 25.985C25.2359 26.0365 25.3802 26.0914 25.5219 26.154C26.4934 26.5837 27.371 27.3514 27.68 28.3722C27.8986 29.0952 27.8175 29.8707 27.7347 30.622C27.4402 33.2768 27.1465 35.9307 26.852 38.5854H30.6466L32.7321 27.8807C32.768 27.6954 32.7714 27.5127 32.7449 27.3377C32.7364 27.2794 32.7244 27.2219 32.7099 27.1653C32.68 27.0529 32.6391 26.9449 32.5861 26.8419C32.5597 26.7905 32.5315 26.7416 32.4999 26.6935C32.4376 26.5975 32.3642 26.5091 32.2831 26.4285C32.12 26.2681 31.9228 26.142 31.7017 26.0631C31.5907 26.0236 31.4746 25.9962 31.3534 25.9825C31.2928 25.9756 31.2313 25.9722 31.1682 25.9722H28.6729C28.6498 25.973 28.6276 25.9765 28.6054 25.9773H28.5866V25.9782Z"
      fill="#3A4920"
    />
    <path
      d="M25.3418 52.203H26.6821C26.7299 52.203 26.7768 52.2013 26.8238 52.197C26.9168 52.1884 27.0082 52.1721 27.097 52.1481C27.1857 52.1241 27.2711 52.0924 27.3531 52.0546C27.435 52.016 27.5136 51.9714 27.587 51.92C27.6698 51.8625 27.7475 51.7964 27.8183 51.7244C27.8892 51.6523 27.9532 51.5726 28.0096 51.4868C28.1222 51.3161 28.2033 51.1214 28.2452 50.9104L30.5595 39.0322H26.8024C26.3158 43.4222 25.8292 47.813 25.3427 52.203H25.3418Z"
      fill="#3A4920"
    />
    <path
      d="M26.8505 38.5853H16.1479L18.6987 26.0338L18.5152 25.9961H18.2522L15.6937 38.5853H2.42838V38.587L2.34131 39.0322H15.6032L12.9261 52.203H13.3803L16.0565 39.0322H26.801H30.5589L30.6084 38.774L30.6451 38.5853H26.8505Z"
      fill="#FF945A"
    />
    <path
      d="M62.4759 38.2971L61.2508 44.5853L61.2295 44.6959L62.4759 38.2971Z"
      fill="#61763D"
    />
    <path
      d="M65.6422 29.4853C64.3105 28.7125 62.359 29.6046 61.2842 31.4762C60.2085 33.3478 60.416 35.4913 61.7477 36.2642C63.0795 37.037 65.031 36.1449 66.1058 34.2733C67.1814 32.4017 66.974 30.2582 65.6422 29.4853ZM65.3025 33.2457C64.7723 34.8557 63.5925 35.9116 62.6688 35.6037C61.7452 35.2966 61.4259 33.7424 61.956 32.1324C62.4862 30.5224 63.6659 29.4665 64.5896 29.7744C65.5133 30.0815 65.8326 31.6357 65.3025 33.2457Z"
      fill="#F365BF"
    />
    <path
      d="M65.4635 29.3061C64.1318 28.5333 62.1802 29.4254 61.1055 31.297C60.0298 33.1686 60.2373 35.3121 61.569 36.085C62.9008 36.8578 64.8523 35.9657 65.9271 34.0941C67.0027 32.2225 66.7952 30.079 65.4635 29.3061ZM65.1237 33.0665C64.5936 34.6765 63.4138 35.7324 62.4901 35.4245C61.5665 35.1174 61.2472 33.5632 61.7773 31.9532C62.3074 30.3432 63.4872 29.2873 64.4109 29.5952C65.3346 29.9023 65.6539 31.4565 65.1237 33.0665Z"
      fill="#FFD7F0"
    />
    <path
      d="M60.5915 31.8322C59.6294 30.1579 57.8844 29.361 56.6936 30.0524C55.5027 30.7428 55.3174 32.6599 56.2795 34.3343C57.2416 36.0086 58.9865 36.8054 60.1774 36.1141C61.3683 35.4236 61.5536 33.5065 60.5915 31.8322ZM58.9404 35.6226C58.558 35.6801 58.1755 35.5145 57.8503 35.1946C57.3381 34.8283 56.9232 34.0932 56.7909 33.2029C56.5877 31.8408 57.1212 30.6322 57.9818 30.5027C58.3642 30.4452 58.7467 30.6108 59.0719 30.9307C59.5841 31.297 59.999 32.032 60.1313 32.9224C60.3345 34.2845 59.801 35.4931 58.9404 35.6226Z"
      fill="#FFD7F0"
    />
    <path
      d="M57.0145 33.3917C56.8113 32.0296 57.3449 30.821 58.2054 30.6915C58.5033 30.6469 58.8013 30.7369 59.0727 30.9308C58.7475 30.61 58.365 30.4444 57.9826 30.5028C57.1221 30.6323 56.5885 31.8417 56.7917 33.203C56.9249 34.0933 57.3398 34.8284 57.8511 35.1947C57.4448 34.7932 57.128 34.1491 57.0145 33.3925V33.3917Z"
      fill="#F365BF"
    />
    <path
      d="M61.1011 39.6572C62.6037 39.1634 63.5151 37.8211 63.1368 36.659C62.7586 35.4969 61.2339 34.955 59.7313 35.4488C58.2288 35.9425 57.3174 37.2849 57.6956 38.447C58.0739 39.6091 59.5986 40.1509 61.1011 39.6572Z"
      fill="#F365BF"
    />
    <path
      d="M61.5005 39.6567C63.0031 39.1629 63.9145 37.8206 63.5362 36.6585C63.158 35.4964 61.6333 34.9545 60.1308 35.4483C58.6282 35.942 57.7168 37.2844 58.0951 38.4465C58.4733 39.6086 59.998 40.1504 61.5005 39.6567Z"
      fill="#FFD7F0"
    />
    <path
      d="M59.3288 44.4663L57.7563 52.2032H64.7821C65.0681 49.624 65.3541 47.0456 65.6401 44.4663H59.3288Z"
      fill="#2EAFC0"
    />
    <path
      d="M60.6191 36.8091L54.9609 36.798C54.9481 36.798 54.9353 36.7954 54.9225 36.7954H53.5378C53.0905 36.7954 52.7055 37.1136 52.6193 37.5545L51.3242 44.2038H59.1158L60.6191 36.8091Z"
      fill="#2EAFC0"
    />
    <path
      d="M51.2732 44.4663L49.9841 51.0822C49.8706 51.6629 50.3137 52.2032 50.9027 52.2032H57.4906L59.063 44.4663H51.2732Z"
      fill="#2EAFC0"
    />
    <path
      d="M59.3818 44.2048H65.6683C65.8408 42.6454 66.0141 41.0868 66.1865 39.5274C66.2352 39.0866 66.283 38.6311 66.1549 38.2056C65.9731 37.6061 65.4583 37.1549 64.8872 36.9027C64.8044 36.8658 64.7199 36.8332 64.6345 36.8032L61.1285 36.8101H60.7725L60.88 36.8315L59.3818 44.2039V44.2048Z"
      fill="#2EAFC0"
    />
    <path
      d="M66.6888 36.799L64.6357 36.8032C64.7211 36.8333 64.8056 36.8659 64.8884 36.9027C65.4595 37.1558 65.9743 37.6061 66.1561 38.2057C66.2851 38.6303 66.2372 39.0857 66.1877 39.5275C66.0153 41.0869 65.842 42.6454 65.6695 44.2048H67.8985L69.1235 37.9166C69.1449 37.8077 69.1466 37.7005 69.1312 37.5975C69.1261 37.5632 69.1193 37.5298 69.1107 37.4963C69.0937 37.4303 69.0689 37.3668 69.0382 37.3068C69.0228 37.2767 69.0057 37.2476 68.9878 37.2193C68.9511 37.1626 68.9084 37.1112 68.8606 37.064C68.765 36.9697 68.6489 36.8959 68.5191 36.8496C68.4543 36.8264 68.386 36.8101 68.3142 36.8024C68.2784 36.7981 68.2425 36.7964 68.2058 36.7964H66.7401C66.7264 36.7964 66.7136 36.799 66.6999 36.7998H66.6888V36.799Z"
      fill="#016B83"
    />
    <path
      d="M64.7826 52.203H65.5697C65.5979 52.203 65.6252 52.2021 65.6525 52.1996C65.7071 52.1944 65.7609 52.185 65.813 52.1713C65.8651 52.1575 65.9154 52.1387 65.9632 52.1164C66.011 52.0941 66.0571 52.0675 66.1007 52.0374C66.1493 52.0031 66.1954 51.9654 66.2364 51.9225C66.2782 51.8796 66.3158 51.8333 66.3491 51.7835C66.4157 51.6832 66.4635 51.5691 66.4874 51.4447L67.8465 44.4678H65.6397C65.3537 47.047 65.0677 49.6254 64.7817 52.2047L64.7826 52.203Z"
      fill="#016B83"
    />
    <path
      d="M65.6694 44.2046H59.3821L60.8803 36.8314L60.7727 36.8099L60.6191 36.8091L59.1157 44.2046H51.3242L51.3233 44.2055L51.2729 44.4662H59.0628L57.4903 52.2032H57.7567L59.3291 44.4662H65.6395H67.8472L67.8762 44.3153L67.8984 44.2046H65.6694Z"
      fill="#FFD7F0"
    />
    <path
      d="M55.664 23.3705C55.664 23.3705 56.7584 19.7121 58.8892 17.5H55.5684L55.664 23.3705Z"
      fill="#112231"
    />
    <path
      d="M33.845 23.0188C34.971 21.4697 35.3713 19.6719 34.9419 18.0842C34.5433 16.62 33.4753 15.5358 32.0095 15.1009C32.0206 14.9783 32.0283 14.8556 32.0317 14.733C32.0727 13.1341 31.4145 11.7857 30.1784 10.9365C28.9149 10.0702 27.2272 9.89009 25.548 10.4416C23.4787 11.121 21.7526 12.7936 21.0431 14.8059L20.6197 16.3481L20.8135 15.0769L20.8186 15.034C20.9475 13.2928 20.2475 11.7849 18.897 10.8971C17.3202 9.85921 15.2057 9.86178 13.2396 10.9048C11.5528 11.8012 10.2979 13.3134 9.77882 15.0083C8.08854 15.3445 6.49044 16.3936 5.43017 17.9118C4.15904 19.7362 3.89867 21.8412 4.73357 23.5438C5.44383 24.9934 6.83533 25.8752 8.5555 25.9729C8.57769 25.9738 8.59904 25.9772 8.62123 25.9781L18.2542 25.997H18.5171L19.1232 25.9987L25.0922 25.9867L28.588 25.9798H28.6068C28.6298 25.9781 28.652 25.9755 28.6742 25.9738C30.6488 25.864 32.5789 24.7644 33.8467 23.0197L33.845 23.0188ZM10.6504 16.264C10.659 16.1808 10.6718 16.0976 10.6846 16.0144C10.7939 16.0084 10.904 16.0067 11.0132 16.0084C12.2468 16.0282 13.2627 16.5471 13.8748 17.47L16.8063 23.0875L11.7816 19.3048C10.9245 18.586 10.5224 17.5061 10.6504 16.264ZM8.65794 24.8613C7.32961 24.7978 6.26251 24.1382 5.72896 23.0497C5.07589 21.7185 5.30468 20.0364 6.33849 18.5517C7.13924 17.4057 8.29683 16.5788 9.53979 16.2152C9.39381 17.8174 9.93932 19.2207 11.0824 20.1728L17.3339 24.8793L8.65794 24.8613ZM19.7114 14.9294L18.378 23.6956L14.8454 16.9262L14.8181 16.8799C13.9994 15.6242 12.6549 14.9182 11.032 14.8925C11.0209 14.8925 11.009 14.8925 10.9979 14.8925C11.4998 13.6573 12.4807 12.5697 13.757 11.8912C15.3593 11.0412 17.053 11.0189 18.2866 11.8303C19.2829 12.4856 19.8019 13.6153 19.7106 14.9302L19.7114 14.9294ZM22.0966 15.1601C22.6976 13.4755 24.1514 12.0739 25.8929 11.5018C27.2417 11.0592 28.5752 11.1887 29.5518 11.8578C30.4652 12.4856 30.9518 13.4961 30.9211 14.7038C30.9194 14.7707 30.9134 14.8367 30.9091 14.9037C29.2282 14.787 27.4278 15.4569 26.0056 16.7761L19.8813 23.2333L22.0966 15.161V15.1601ZM30.7 16.0093C30.2962 17.2951 29.3665 18.4745 28.0928 19.2567L21.7662 22.8619L26.7713 17.5833C27.9281 16.5162 29.3631 15.9561 30.6991 16.0093H30.7ZM28.5666 24.8613L20.4806 24.8785L28.6563 20.2191C30.2134 19.2627 31.3368 17.8003 31.7987 16.2049C32.847 16.5497 33.5803 17.3165 33.8689 18.3784C34.2086 19.6359 33.8723 21.0872 32.9469 22.361C31.8636 23.8509 30.227 24.7858 28.5658 24.8622L28.5666 24.8613Z"
      fill="#FF4F40"
    />
    <g filter="url(#filter0_d_686_1576)">
      <path
        d="M55.7971 2.83435C54.0666 10.5584 53.3427 11.2806 46.2222 13.1025C53.7679 14.6156 54.5643 15.24 55.7971 23.3707C56.7984 17.8107 57.466 15.7324 60.1611 14.5049C61.1949 14.0349 62.5266 13.6892 64.2895 13.3212C64.6335 13.2492 64.9938 13.1763 65.3719 13.1017C58.0704 11.2266 57.3661 10.4864 55.7971 2.8335V2.83435Z"
        fill="white"
      />
    </g>
    <path
      d="M5.20222 31.0186C5.20222 31.0186 3.41119 33.5421 3.08936 35.195L3.90291 31.0186H5.20222Z"
      fill="#112231"
    />
    <g filter="url(#filter1_d_686_1576)">
      <path
        d="M5.20233 31.0183C3.63839 32.0227 3.17399 32.8376 2.60117 35.5816C2.02835 32.8368 1.5648 32.0227 0 31.0183C1.56394 30.0139 2.02835 29.199 2.60117 26.4551C3.17399 29.1999 3.63754 30.0139 5.20233 31.0183Z"
        fill="white"
      />
    </g>
    <path
      d="M6.05846 36.8219C6.70344 36.8219 7.2263 36.2966 7.2263 35.6485C7.2263 35.0004 6.70344 34.4751 6.05846 34.4751C5.41348 34.4751 4.89062 35.0004 4.89062 35.6485C4.89062 36.2966 5.41348 36.8219 6.05846 36.8219Z"
      fill="#112231"
    />
    <path
      d="M5.74987 36.5734C6.39484 36.5734 6.9177 36.048 6.9177 35.4C6.9177 34.7519 6.39484 34.2266 5.74987 34.2266C5.10489 34.2266 4.58203 34.7519 4.58203 35.4C4.58203 36.048 5.10489 36.5734 5.74987 36.5734Z"
      fill="#FFA9DF"
    />
    <g filter="url(#filter2_d_686_1576)">
      <path
        d="M77.0183 29.5051C74.7825 30.8878 74.1192 32.008 73.3014 35.7855C72.4827 32.0089 71.8194 30.8878 69.5845 29.5051C71.8203 28.1224 72.4836 27.0022 73.3014 23.2246C74.1201 27.0013 74.7834 28.1224 77.0183 29.5051Z"
        fill="white"
      />
    </g>
    <g filter="url(#filter3_d_686_1576)">
      <path
        d="M80 37.9659C78.7485 38.7696 78.3771 39.4215 77.9187 41.6174C77.4603 39.4215 77.0889 38.7696 75.8374 37.9659C77.0889 37.1622 77.4603 36.5103 77.9187 34.3145C78.3771 36.5103 78.7485 37.1622 80 37.9659Z"
        fill="white"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_686_1576"
        x="46.2222"
        y="2.8335"
        width="19.1499"
        height="21.5371"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_686_1576"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_686_1576"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_686_1576"
        x="0"
        y="26.4551"
        width="5.20215"
        height="10.1265"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_686_1576"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_686_1576"
          result="shape"
        />
      </filter>
      <filter
        id="filter2_d_686_1576"
        x="69.5845"
        y="23.2246"
        width="7.43408"
        height="13.561"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_686_1576"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_686_1576"
          result="shape"
        />
      </filter>
      <filter
        id="filter3_d_686_1576"
        x="75.8374"
        y="34.3145"
        width="4.1626"
        height="8.30273"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_686_1576"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_686_1576"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
)
export default SvgRewards
